module.exports = __webpack_public_path__ + "be237328d9c252b1b9133a02c3be3e5e.svg";